import { Grid } from "@material-ui/core";
import footerImage from "../../../assets/image/footer.svg";
import useStyles from "../../../styles";
import footerLogoImage from "../../../assets/image/logo.svg";
export default function DeskFooter() {
  const classes = useStyles();
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="flex-end"
      className={classes.footerContainer}
    >
      <img
        src={footerImage}
        alt="footer"
        className={classes.footerBackground}
      />
      <img
        src={footerLogoImage}
        alt="footerLogo"
        style={{height:90}}
        className={classes.footerLogo}
      />
      <Grid container justify="center">
        <span className={classes.footerAddressText}>
          تهران، خیابان شریعتی، پایین تر از ملک، کوچه شکوری، پلاک8{" "}
        </span>
        <Grid item className={classes.verticalLineFooter} />
        <span className={classes.footerAddressText}>02177500130 </span>
      </Grid>
      <Grid container justify="center">
        <span className={classes.footerText2}>
          تمام حقوق مادی و معنوی این پورتال متعلق به اتحادیه انجمن‌های اسلامی
          دانش‌آموزان بوده و نشر محتوای آن با ذکر منبع بلامانع است. © 1404
        </span>
      </Grid>
    </Grid>
  );
}
